import React from "react";
import Banner from "../components/accomodation/banner";
import GuestRoom from "../components/accomodation/rooms";
import GalFooter from "../components/gallery/gallery-footer";

function Accomodation() {
  return (
    <>
      <Banner />
      <GuestRoom />
      <GalFooter />
    </>
  );
}

export default Accomodation;
